import React, { Component } from 'react';
import './About.css'
import img from '../img/team/2.jpeg';

class About extends Component {
  render() {
    return (
      <div id='about' className="about">
       
        
    
      
        <div className="col-lg-12 text-center team-member">
          <h1 className="section-heading text-uppercase">About</h1>
          <h3 className="section-subheading text-muted">Lorem ipsum dolor sit amet consectetur.</h3>
        </div>
      
      
          <div className="team-member">
            <img className=""  src={img} alt="" ></img>
            <h4>Abdullah Delowar</h4>
            <p className="text-muted">web Designer</p>
            <ul className="social ">
              <li >
                <a href="1">
                  <i className="fab fa-twitter"></i>
                </a>
              </li>
              <li >
                <a href="2">
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>
              <li >
                <a href="3">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </li>
            </ul>
            </div>
            <div className="container team-member">
                <h2 className="section-heading text-center">I'm a dedicated web developer</h2>
                <p className=" text-center">Being that I've based my business off of the platform, there's nothing I can't handle. Below you'll find a selection of some of my most recent projects that showcase the type of clients I work closely with.</p>
            </div>
        </div>
      
    );
  }
}

export default About;



